import st from "@/styles/Ui.module.scss";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import {useTranslation} from "react-i18next";
// import {penalty_amount} from "@/utils/constants.ts";
import DividerSimple from "@/ui/DividerSimple.tsx";
import clsx from "clsx";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import Images from "@/utils/images.ts";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import React from "react";
import {loansReqs} from "@/services/loans.ts";

interface ObjectInterface {
    credit:LoanInterface
    all:"0" | "1"
}

const PayCreditModal = () => {
    const [local_credit, set_local_credit] = useState<ObjectInterface | undefined>(undefined)
    const effect_ran = useRef<boolean>(false)
    const {t, i18n} = useTranslation()
    // const penalities = (local_credit?.credit?.restant_days || 0) * penalty_amount
    const cms_banks = CMS.banks.repeater ?? []
    const online_payment = CMS.online_payment.repeater ?? []
    const e_payments = CMS.e_payments.repeater ?? []
    const stores = CMS.stores.repeater ?? []

    const all_payment_methods = [...cms_banks, ...online_payment, ...e_payments, ...stores ]

    const navigate = useNavigate()
    let amn = (typeof local_credit?.credit !== "undefined" && local_credit?.credit?.loan_age > 0) ? local_credit?.credit?.disc_amount : local_credit?.credit?.inst_amount
    // const total = penalities + Number(amn)
    // const penality = (local_credit?.credit.restant_days || 0) * penalty_amount
    
    if(local_credit?.all === "1") {
        amn === local_credit?.credit.capital
    }
    
    const openModal = (x:ObjectInterface | undefined) => {
        set_local_credit(x)
    }
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.PayCreditModalOpen, openModal)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.ModalEvents.PayCreditModalOpen, openModal)
            }
        }
    }, []);

    const getPaymentType = (label: string) => {
        switch (label) {
            case "oplata": return "standard"
            case "mia": return "mia"
            default: return "standard"
        }
    }

    const handlePayment = async (val: string) => {
        const payload = {
            payment_method: val,
            language: i18n.language as LocalLanguage,
            urn: local_credit?.credit?.urn || "",
            ...(val === "standard" && {payment_option: local_credit?.all || 0}),
            ...(val === "mia" && local_credit?.all === "1" && {amount: local_credit?.credit?.disc_amount})
        }

        const response = await loansReqs().oplata_pay(payload);

        if (response.status === 200) {
            // Create a Blob and URL
            const blob = new Blob([response.response], { type: "text/html" });
            const url = URL.createObjectURL(blob)

            // Open in a new tab
            window.open(url, "_blank");
        } else {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar,"error", t("error_message"))
        }
    }

    return local_credit && (
        <ModalLayout
            className={st.pay_credit_modal}
            open={Boolean(local_credit)}
            innerClassName={st.pay_credit_modal_inner}
            on_close_state={() => {
                set_local_credit(undefined)
            }}
        >
            
            <>
                <div className={st.top}>
                    <h4>{t("peyment")}</h4>
                    
                    <div className={st.payment_inf}>
                        {/*<div className={st.row}>*/}
                        {/*    <span className={st.gray}>*/}
                        {/*        {t("to_pay")}*/}
                        {/*    </span>*/}
                        {/*    */}
                        {/*    <span className={st.black}>*/}
                        {/*        {`${CommonClass.formatMoneyAmount(Number(amn))} ${t("currency")}`}*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        
                        {/*<DividerSimple/>*/}
                        
                        {/*{penality ? (*/}
                        {/*    <>*/}
                        {/*        <div className={clsx(st.row, st.total)}>*/}
                        {/*            <span className={st.gray}>*/}
                        {/*                {t("penalities")}*/}
                        {/*            </span>*/}
                        {/*            */}
                        {/*            <span className={clsx(st.black, st.danger)}>*/}
                        {/*                {`${CommonClass.formatMoneyAmount(penality)} ${t("currency")}`}*/}
                        {/*            </span>*/}
                        {/*        </div>*/}
                        {/*        */}
                        {/*        <DividerSimple/>*/}
                        {/*    </>*/}
                        {/*) : null}*/}
                        
                        <div className={clsx(st.row, st.total)}>
                            <span className={st.gray}>
                                {t("to_pay")}
                            </span>
                            
                            <span className={clsx(st.black, local_credit.credit.loan_age > 0 && st.danger)}>
                                {`${local_credit?.all === "1" ?
                                    CommonClass.formatMoneyAmount(Number(local_credit.credit.disc_amount))
                                    : CommonClass.formatMoneyAmount(Number(local_credit?.credit.inst_amount))} ${t("currency")}`
                                }
                            </span>
                        </div>
                    </div>
                </div>
                
                <div className={st.body_container}>
                    <div className={st.body}>
                        
                        <strong>
                            {t("select_payment_method")}
                        </strong>

                        <div className={st.methods_cont}>
                            <div className={st.methods}>



                                {(Array.isArray(all_payment_methods) && all_payment_methods.length) ? all_payment_methods.map((obj: any, i: number) => {

                                    const bank_obj = CMS.langAwareFilter(obj, i18n.language as LocalLanguage)
                                    const {name, label_image, label} = bank_obj

                                    return (
                                        <React.Fragment key={`bank_obj_${i}`}>
                                            <button
                                                onClick={() => {
                                                    if(bank_obj["function"]){
                                                        handlePayment(getPaymentType(label))
                                                    } else {
                                                        set_local_credit(undefined)
                                                        navigate(DashboardClass.dashboard_routes.Bank + "/" + label)
                                                    }
                                                }}

                                                className={st.bank}

                                            >
                                                <img src={CMS.getFilePath(label_image[0].path)} alt="bank"/>

                                                <span>
                                                {name}
                                            </span>

                                                <ChevroneIcon />
                                            </button>

                                            {(i !== all_payment_methods.length - 1) && (
                                                <DividerSimple />
                                            )}
                                        </React.Fragment>
                                    )
                                }) : null}

                                {/*{(i !== cms_banks.length - 1) && (*/}
                                {/*    <DividerSimple />*/}
                                {/*)}*/}
                            </div>
                        </div>
                        

                        <button
                            onClick={() => {
                                set_local_credit(undefined)
                                navigate(DashboardClass.dashboard_routes.Locations)
                            }}
                            className={st.locations}
                        >
                            <img src={Images.logos.TextlessLogo} alt="locations"/>
                            
                            <span>{t("offices")}</span>
                            
                            <ChevroneIcon />
                        </button>
                    
                    
                    </div>
                </div>
            
            </>
        
        </ModalLayout>
    )
}

export default PayCreditModal